import React from "react";

import { useTranslation } from "react-i18next";

import { StandardLayout } from "@/components/layouts";
import { DocumentPreview } from "@/components/organisms";
import config from "@/config";
import { UrlManager } from "@/shared/apis/UrlManager";

const url = `${config.SPAPI_URL}/api${UrlManager.invoiceContent()}`;

const InvoicePreview = () => {
    const { t } = useTranslation();

    return (
        <StandardLayout disableSearch>
            <DocumentPreview url={url} title={t("Common.Invoice")} />
        </StandardLayout>
    );
};

export default InvoicePreview;
